import Comment from './Comment';
export default Comment;


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/common/comment/index.js